/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const brandingDataGenerationErrorSchema = z.enum(['website_unreachable', 'scan_failed'])

export type BrandingDataGenerationErrorSchema = z.infer<typeof brandingDataGenerationErrorSchema>
